import { GameDisplay } from "../../http/protocol";
import { t } from "../../i18n";
import { SeoMetadataEditor } from "../seo/SeoMetadataEditor";
import { CasinoGameSeoDraft } from "./casinoGameSeoDraft";
import { gameFallbackInputs } from "./casinoSeoFallbackInputs";
import { casinoGameSeoDisplayUrl } from "./casinoSeoUrl";
import { SeoDraftEditorShell } from "./SeoDraftEditorShell";

export interface CasinoGameSeoEditorProps {
  draft: CasinoGameSeoDraft;
  /** Undefined until the game has been saved once. */
  gameId?: number;
  gameName?: string;
  gameDisplay?: GameDisplay;
}

/** A casino game's SEO editor. It loads the game's SEO into the draft its host saves after the game. */
export function CasinoGameSeoEditor({ draft, gameId, gameName, gameDisplay }: CasinoGameSeoEditorProps): JSX.Element {
  return (
    <div data-testid="seo-game-section">
      <h4>{t("admin.seo.heading", undefined, "SEO")}</h4>
      <SeoDraftEditorShell
        draft={draft}
        targetId={gameId}
        saveFirstMessage={t("admin.seo.save-game-first", undefined, "Save the game first to add SEO.")}
        saveFirstTestId="seo-game-save-first"
        testIdPrefix="seo-game"
        renderFields={(context) => (
          <SeoMetadataEditor
            locales={context.locales ?? []}
            values={draft.getValues()}
            fallbackInputs={gameFallbackInputs(context)}
            displayUrl={casinoGameSeoDisplayUrl({ id: gameId, name: gameName, display: gameDisplay })}
            onChange={(locale, field, value) => draft.setField(locale, field, value)}
            testIdPrefix="seo-game"
          />
        )}
      />
    </div>
  );
}
